import React from 'react';

import { AddPath, Path, RemainingPath } from './Path/index';
import { PATHS_CAPACITY } from '../../constants/JourneyBuilder';

const PageOne = ({ outcomes, readonlyForm }) => {
  const [remaining, ...rest] = [...(outcomes || [])].reverse();
  const decisions = rest.reverse();

  return (
    <React.Fragment>
      {decisions &&
        decisions.map((item, index) => (
          <Path
            key={item.arguments.branchResult}
            item={item}
            index={index}
            readonlyForm={readonlyForm}
          />
        ))}
      <AddPath disabled={readonlyForm || decisions.length + 1 >= PATHS_CAPACITY} />
      {remaining && (
        <RemainingPath item={remaining} index={outcomes.length - 1} readonlyForm={readonlyForm} />
      )}
    </React.Fragment>
  );
};

PageOne.displayName = 'PageOne';

export default PageOne;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/PageOne.js